import { onscroll } from "./../../../../../../node_modules/onscroll-effect/dist/onscroll-effect.es6.js";

const animSections = ( animSectionsWrappers ) => {
    for ( let animSectionsWrapper of animSectionsWrappers ) {
        const animSections = animSectionsWrapper.querySelectorAll("div");
        const firstSection = animSectionsWrapper.querySelector("[data-scroll]");
        const secondSection = animSectionsWrapper.querySelector(".animated-section-2");
        const thirdSection = animSectionsWrapper.querySelector(".animated-section-3");
        let loop = animSectionsWrapper.getAttribute('data-loop') ? false : true;
        let firstSectionClasses = firstSection.getAttribute('class');
        const winHeight = window.innerHeight;
        let midDistance = 0;
        let wrapperHeight = 0; // to save highest element
        let running = false;
        // Time
        let starttime = 2000;
        let timesAr = [starttime, starttime + 500, starttime + 510, starttime + 2000, starttime + 2500, starttime + 2510] ;
        let loop_wait = 3000;
        let loop_timer = timesAr[2] + loop_wait;
    
        const animateText = () => {
            console.log('started anim');
            if ( secondSection ) {
                setTimeout(()=>{
                    firstSection.classList.add('is-up');
                }, timesAr[0]);
                setTimeout(()=>{
                    secondSection.classList.remove('is-outside');
                }, timesAr[1]);
                if ( !thirdSection ) {
                    setTimeout(()=>{
                        running = false;
                        console.log('finished anim');
                    }, timesAr[2]);
                }
            }
            if ( thirdSection ) {
                loop_timer = timesAr[5] + loop_wait;
                setTimeout(()=>{
                    secondSection.classList.add('is-up');
                }, timesAr[3]);
                setTimeout(()=>{
                    thirdSection.classList.remove('is-outside');
                }, timesAr[4]);
                setTimeout(()=>{
                    running = false;
                    console.log('finished anim');
                }, timesAr[5]);
            }
        }

        const resetAnim = () => {
            firstSection.classList.remove('is-up');
            secondSection ? secondSection.classList.remove('is-up') : null;
            secondSection ? secondSection.classList.add('is-outside') : null;
            thirdSection ? thirdSection.classList.remove('is-up') : null;
            thirdSection ? thirdSection.classList.add('is-outside') : null;
        }
    
        // Calc container height
        for ( let animSection of animSections ) {
            let rh = animSection.scrollHeight;
            ( rh > wrapperHeight ) ? wrapperHeight = rh : null; // get highest element
        }
        animSectionsWrapper.style.height = wrapperHeight + 'px'; 
        midDistance = ( winHeight - wrapperHeight ) / 2;
        
        // Check if data-scroll is in the screen
        firstSection.addEventListener("insideViewport", (event) => {
            firstSectionClasses = firstSection.getAttribute('class');
            console.log('scroll-event inside');
            if ( running != true && firstSectionClasses.indexOf('is-up') == -1 ) {
                animateText();
                if ( loop ) {
                    // anim looping, no scroll event
                    setInterval( ()=>{ resetAnim(); animateText() }, loop_timer);
                }
            } else if ( running != true && firstSectionClasses.indexOf('is-up') >= 0 && !loop ) {
                resetAnim();
                setTimeout(()=>{
                    animateText();
                }, 500);
            }
        });    
    }
};

export { animSections };